export const rodTranslations = {
  "Vara de Junco": {
    name: {
      en: "Reed Rod",
      es: "Caña de Junco",
      zh: "芦苇钓竿"
    },
    description: {
      en: "Simple and practical for casual fishermen",
      es: "Simple y práctica para pescadores ocasionales",
      zh: "适合休闲钓鱼的简单实用钓竿"
    }
  },
  "Vara do Lago Sereno": {
    name: {
      en: "Serene Lake Rod",
      es: "Caña del Lago Sereno",
      zh: "平静湖泊钓竿"
    },
    description: {
      en: "Ideal for calm and crystalline waters",
      es: "Ideal para aguas tranquilas y cristalinas",
      zh: "适合平静清澈水域的理想钓竿"
    }
  },
  "Vara do Pescador Noturno": {
    name: {
      en: "Night Fisher's Rod",
      es: "Caña del Pescador Nocturno",
      zh: "夜行渔人竿"
    },
    description: {
      en: "Perfect for fishing under the stars",
      es: "Perfecta para pescar bajo las estrellas",
      zh: "适合在星空下钓鱼的完美钓竿"
    }
  },
  "Vara do Rio Selvagem": {
    name: {
      en: "Wild River Rod",
      es: "Caña del Río Salvaje",
      zh: "野河钓竿"
    },
    description: {
      en: "Robust for facing intense currents",
      es: "Robusta para enfrentar corrientes intensas",
      zh: "能够应对激流的坚固钓竿"
    }
  },
  "Vara do Oceano Profundo": {
    name: {
      en: "Deep Ocean Rod",
      es: "Caña del Océano Profundo",
      zh: "深海钓竿"
    },
    description: {
      en: "For those who challenge the depths of the sea",
      es: "Para los que desafían las profundidades del mar",
      zh: "为挑战深海的勇者准备"
    }
  },
  "Vara da Maré Alta": {
    name: {
      en: "High Tide Rod",
      es: "Caña de Marea Alta",
      zh: "涨潮钓竿"
    },
    description: {
      en: "Adaptable to any type of tide",
      es: "Adaptable a cualquier tipo de marea",
      zh: "适应各种潮汐的钓竿"
    }
  },
  "Vara do Guardião das Águas": {
    name: {
      en: "Water Guardian's Rod",
      es: "Caña del Guardián de las Aguas",
      zh: "水之守护者钓竿"
    },
    description: {
      en: "Carries the blessing of an ancient water protector",
      es: "Lleva la bendición de un antiguo protector acuático",
      zh: "携带着古代水之守护者的祝福"
    }
  },
  "Vara da Tempestade": {
    name: {
      en: "Storm Rod",
      es: "Caña de la Tormenta",
      zh: "风暴钓竿"
    },
    description: {
      en: "Capable of withstanding the worst weather conditions",
      es: "Capaz de soportar las peores condiciones climáticas",
      zh: "能够承受最恶劣天气的钓竿"
    }
  },
  "Vara do Leviatã": {
    name: {
      en: "Leviathan Rod",
      es: "Caña del Leviatán",
      zh: "利维坦钓竿"
    },
    description: {
      en: "Only for the bravest fishermen",
      es: "Solo para los pescadores más valientes",
      zh: "只为最勇敢的渔人打造"
    }
  },
  "Vara do Pescador Fantasma": {
    name: {
      en: "Ghost Fisher's Rod",
      es: "Caña del Pescador Fantasma",
      zh: "幽灵渔人竿"
    },
    description: {
      en: "They say it's haunted by a fisherman's spirit",
      es: "Dicen que está embrujada por el espíritu de un pescador",
      zh: "据说被一位渔夫的灵魂所附身"
    }
  },
  "Vara do Horizonte": {
    name: {
      en: "Horizon Rod",
      es: "Caña del Horizonte",
      zh: "地平线钓竿"
    },
    description: {
      en: "Reaches the most distant fish",
      es: "Alcanza los peces más distantes",
      zh: "可以钓到最远处的鱼"
    }
  },
  "Vara do Tritão": {
    name: {
      en: "Triton's Rod",
      es: "Caña del Tritón",
      zh: "海神钓竿"
    },
    description: {
      en: "Wrapped in oceanic magic",
      es: "Envuelta en magia oceánica",
      zh: "蕴含海洋魔力"
    }
  },
  "Vara da Eternidade": {
    name: {
      en: "Eternity Rod",
      es: "Caña de la Eternidad",
      zh: "永恒钓竿"
    },
    description: {
      en: "Made to last generations",
      es: "Hecha para durar generaciones",
      zh: "为世代传承而制"
    }
  },
  "Vara do Destino": {
    name: {
      en: "Destiny Rod",
      es: "Caña del Destino",
      zh: "命运钓竿"
    },
    description: {
      en: "They say it chooses its own fisherman",
      es: "Dicen que ella elige a su propio pescador",
      zh: "据说它会自己选择主人"
    }
  }
};
